export const ReportIncidentSliceConstants = {
  SendReport: 'sendReport',
  ConvertImageToPath: 'convertImageToPath',
};
